import Button from "../../../common/button";
import ContactStyleWrapper from "./Contact.style";
import { FaMap, FaRegEnvelope, FaPhoneVolume } from "react-icons/fa";

const Contact = () => {
  return (
    <ContactStyleWrapper>
      <div className="container">
        <div className="row">
          <h2 className="uppercase get_in_touch_title">Get In Touch</h2>
          <div className="get_in_touch">
            <div className="get_in_touch_item">
              <div className="icon">
                <FaMap />
              </div>
              <h6>Location</h6>
              <p>Melborn Cricket Ground,<br />
                Melborn, Australia</p>
            </div>

            <div className="get_in_touch_item">
              <div className="icon">
                <FaPhoneVolume />
              </div>
              <h6>Telephone</h6>
              <p>+012 (345) 678 99 <br /> +012 (345) 678 90</p>
            </div>

            <div className="get_in_touch_item">
              <div className="icon">
                <FaRegEnvelope />
              </div>
              <h6>Email & Web</h6>
              <p> hotline@gmail.com <br />
                example.com </p>
            </div>
          </div>

          <div className="col-md-12">
            <div className="contact_content">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="input_form_box">
                  <div className="form_box">
                    <label htmlFor="name">YOUR Name *</label>
                    <input
                      type="text"
                      placeholder="e.g.  David Warner"
                      name="name"
                    />
                  </div>

                  <div className="form_box">
                    <label htmlFor="mail">Email Addres *</label>
                    <input
                      type="mail"
                      placeholder="e.g.  example@gmail.com"
                      name="mail"
                    />
                  </div>
                </div>

                <div className="input_form_box">
                  <div className="form_box col-md-6">
                    <label htmlFor="phnNo">Phone Number</label>
                    <input
                      type="text"
                      placeholder="e.g.  +55 365 256 2556"
                      name="phnNo"
                    />
                  </div>
                  <div className="form_box col-md-6">
                    <label htmlFor="phnNo">Website</label>
                    <input
                      type="text"
                      placeholder="e.g.  www.example.com"
                      name="website"
                    />
                  </div>
                </div>


                <div className="form_box">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    name="message"
                    placeholder="Type your Message"
                  ></textarea>
                </div>

                <Button lg variant="outline" className="submit_btn">
                  Submit Now
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </ContactStyleWrapper>
  );
};

export default Contact;
